import classnames from "@src/utils/classnames"
import React from "react"
import Clickable from "../clickable"
import * as styles from "./title.module.scss"

const Title = ({
  children,
  sub,
  moreProps,
  moreText,
  className,
  smallMargin,
}) => {
  return (
    <h3
      className={classnames(styles.title, {
        [styles.smMargin]: smallMargin,
        [styles.hasSub]: sub,
        className,
      })}
    >
      <span>
        {children}
        {sub && <small>{sub}</small>}
      </span>
      {moreText ? (
        <Clickable {...moreProps} className={classnames(styles.more)}>
          {moreText}
        </Clickable>
      ) : (
        <span />
      )}
    </h3>
  )
}

export default Title
